import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import I18n from '../../../blocks/localization';
import { RouteComponentProps } from 'react-router';
import { verifyActivationMailActions } from '../../../store/account/actions';
import { VerifyActivationMailRequest } from '../../../models/account/verify-activation-mail/VerifyActivationMailRequest';
import ContentLayoutWithoutNavigation from '../../core/ContentLayoutWithoutNavigation';

type Props = typeof mapDispatchToProps & RouteComponentProps;

const VerifyActivationMail = (props: Props) => {
    const params = new URLSearchParams(props.location.search);
    const code = params.get('code');

    useEffect(() => {
        props.verifyActivationMail({ code: code } as VerifyActivationMailRequest);
        // eslint-disable-next-line
    }, []);

    return (
        <ContentLayoutWithoutNavigation>
            <h1>{I18n.t('verifyActivationMail.title')}</h1>
        </ContentLayoutWithoutNavigation>
    );
}

const mapDispatchToProps = {
    verifyActivationMail: verifyActivationMailActions.request
};

export default connect(null, mapDispatchToProps)(VerifyActivationMail as any);
